module.exports = __webpack_public_path__ + "static/media/Lawrance Statue.2fea62e0.mp3";